import type { v4 } from '@sap/ux-specification-types';
import type { CustomHeaderAction } from './HeaderAction';
import { description, isViewNode } from '../../../common';

@isViewNode
@description('Actions')
export class HeaderActions implements v4.HeaderActions {
    [key: string]: CustomHeaderAction | any;
}

export class Header implements v4.Header {
    actions?: HeaderActions;
}
